// pages/FormViewerPage/hooks/useFormViewer/effectsPixels.ts — Pixel tracking effects (form + thank you page)
import { useEffect } from 'react';
import { getFormPagePixelConfigs, getThankYouPagePixelConfigs } from '../../services/formViewerService';
import { fireFormViewEvent } from '../../services/formViewerService/funnelEvents';
import { pickPlatformPixelIds } from '../../services/formViewerService/pixelOptimization';
import { buildMetaUserDataRaw } from '../../../../utils/pixelPii';
import { getPersistentExternalId } from '../../../../services/attributionIds';
import type { LoadPhase } from '../../../../utils/stagedLoad';
import type { FormViewerState } from './state';

export function useFormViewerPixelEffects(s: FormViewerState, phase: LoadPhase) {
    const { form, globalTrackingSettings, settingsLoading, activePlatform, setFormPagePixelConfigs, setFormPagePixels, setActivePixelIds, setEventNames, setThankYouPagePixelConfigs, setThankYouPagePixels } = s;

    // Pixel tracking: FORM PAGE (config sync murah; FIRE tunggu fase 2 —
    // konten dulu, pixel kemudian; atribusi via queue tetap aman).
    useEffect(() => {
        const result = getFormPagePixelConfigs(form, globalTrackingSettings, settingsLoading, activePlatform);
        setFormPagePixelConfigs(result.allConfigs);
        setFormPagePixels(result.metaConfig);
        setActivePixelIds(result.metaConfig.ids);
        setEventNames(prev => ({ ...prev, formPage: result.metaConfig.eventName }));
        if (phase < 2) return;
        // Ukur FormView (custom, bukan optimasi) — standalone DAN embed.
        // Gagal tracking abaikan; guard sesi di dalam helper.
        if (form?.id) {
            try {
                const base = {
                    content_ids: [form?.slug || ''].filter(Boolean),
                    content_name: form?.title || 'Form',
                };
                const fid = form.id;
                // Init pertama menang: bawa userData (country+externalId) agar
                // matching menempel siapa pun yg init duluan (funnel vs multi).
                const viewUd = buildMetaUserDataRaw({ country: 'id', externalId: getPersistentExternalId() }) || undefined;
                fireFormViewEvent('meta', pickPlatformPixelIds(result.allConfigs, 'meta'), base, `px_formview_meta_${fid}`, viewUd);
                fireFormViewEvent('tiktok', pickPlatformPixelIds(result.allConfigs, 'tiktok'), base, `px_formview_tt_${fid}`);
                fireFormViewEvent('google', pickPlatformPixelIds(result.allConfigs, 'google'), base, `px_formview_g_${fid}`);
            } catch { /* abaikan */ }
        }
    }, [form, globalTrackingSettings, settingsLoading, activePlatform, phase]);

    // Pixel tracking: THANK YOU PAGE
    useEffect(() => {
        const result = getThankYouPagePixelConfigs(form, globalTrackingSettings, settingsLoading, activePlatform);
        setThankYouPagePixelConfigs(result.allConfigs);
        setThankYouPagePixels(result.metaConfig);
        setEventNames(prev => ({ ...prev, thankYouPage: result.metaConfig.eventName }));
    }, [form, globalTrackingSettings, settingsLoading, activePlatform]);
}
